module.exports = __webpack_public_path__ + "img/search-page-find.a4807ea0.svg";